import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * MyPageShell — shared layout for profile-driven pages
 * (My Properties, Saved, Inquiries, Settings…).
 *
 * Provides a clean navy header with back-arrow (mobile) and a scrollable body
 * so every profile section feels like its own dedicated screen.
 */
export default function MyPageShell({ title, subtitle, children, testid, backTo = "/profile" }) {
    return (
        <div className="min-h-[70vh] bg-cream-50" data-testid={testid}>
            <div className="bg-gradient-to-br from-navy-900 to-navy-800 text-white px-5 pt-4 pb-6">
                <div className="flex items-center gap-3">
                    <Link
                        to={backTo}
                        data-testid={`${testid}-back`}
                        className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center shrink-0"
                        aria-label="Back to profile"
                    >
                        <ArrowLeft className="w-5 h-5" />
                    </Link>
                    <div className="min-w-0">
                        <h1 className="font-heading font-bold text-lg sm:text-xl truncate">{title}</h1>
                        {subtitle && <p className="text-[12px] text-white/60 mt-0.5 truncate">{subtitle}</p>}
                    </div>
                </div>
            </div>
            <div className="px-3 sm:px-6 max-w-5xl mx-auto -mt-4 pb-8">
                <div className="bg-white rounded-2xl shadow-sm border border-navy-500/8 p-4 sm:p-5">
                    {children}
                </div>
            </div>
        </div>
    );
}

export function EmptyState({ icon: Icon, title, message, cta, to, testid }) {
    return (
        <div className="text-center py-12 px-4" data-testid={testid}>
            {Icon && (
                <div className="w-16 h-16 rounded-full bg-navy-500/8 flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-8 h-8 text-navy-500/50" />
                </div>
            )}
            <div className="font-heading font-bold text-navy-500 text-base mb-1">{title}</div>
            <p className="text-sm text-navy-500/55 max-w-sm mx-auto">{message}</p>
            {cta && to && (
                <Link
                    to={to}
                    data-testid={`${testid}-cta`}
                    className="mt-5 inline-flex items-center px-5 py-2.5 rounded-lg bg-gold-500 text-navy-500 text-sm font-extrabold hover:bg-gold-400"
                >
                    {cta}
                </Link>
            )}
        </div>
    );
}
